/* Shared ambient layer — a handful of tiny antique-gold (and a few warm
   ivory) specks drifting slowly behind all content. Rendered once for the
   whole site; pure CSS motion; disabled under prefers-reduced-motion. */
const SPECKS = [
    { left: "6%", top: "78%", size: 3, time: "26s", delay: "0s", x: "30px", y: "-140px", o: 0.35, ivory: false },
    { left: "14%", top: "88%", size: 2, time: "32s", delay: "6s", x: "-22px", y: "-160px", o: 0.3, ivory: true },
    { left: "26%", top: "70%", size: 3, time: "24s", delay: "3s", x: "18px", y: "-120px", o: 0.4, ivory: false },
    { left: "38%", top: "84%", size: 2, time: "30s", delay: "9s", x: "-26px", y: "-150px", o: 0.28, ivory: false },
    { left: "52%", top: "76%", size: 3, time: "27s", delay: "1.5s", x: "24px", y: "-130px", o: 0.35, ivory: true },
    { left: "64%", top: "88%", size: 2, time: "34s", delay: "7s", x: "-18px", y: "-170px", o: 0.3, ivory: false },
    { left: "74%", top: "72%", size: 3, time: "25s", delay: "4s", x: "28px", y: "-125px", o: 0.38, ivory: false },
    { left: "86%", top: "82%", size: 2, time: "31s", delay: "11s", x: "-24px", y: "-145px", o: 0.3, ivory: true },
    { left: "94%", top: "68%", size: 3, time: "28s", delay: "2s", x: "-30px", y: "-115px", o: 0.32, ivory: false },
];

export const Ambient = () => (
    <div className="ambient-layer" aria-hidden="true" data-testid="ambient-layer">
        <div className="ambient-glow" />
        {SPECKS.map((p, i) => (
            <span
                key={i}
                className={`particle ${p.ivory ? "particle--ivory" : ""}`}
                style={{
                    left: p.left,
                    top: p.top,
                    width: p.size,
                    height: p.size,
                    "--p-time": p.time,
                    "--p-delay": p.delay,
                    "--p-x": p.x,
                    "--p-y": p.y,
                    "--p-opacity": p.o,
                }}
            />
        ))}
    </div>
);
